import React, { useState } from 'react';
import Navbar from '../../components/navbar/navbar.jsx'

function Precificacao() {
    const [productPrice, setProductPrice] = useState('');
    const [totalPrice, setTotalPrice] = useState('');
    const [categoria, setCategoria] = useState('');
    const [parcelamento, setParcelamento] = useState('');
    const [quantidade, setQuantidade] = useState('');
    const [peso, setPeso] = useState('');
    const [tarifaMinima, setTarifaMinima] = useState(0);
    const [tarifaMaxima, setTarifaMaxima] = useState(0);
    const [custoFixo, setCustoFixo] = useState(0);
    const [commission, setCommission] = useState(0);
    const [frete, setFrete] = useState(0);

    const calcularFrete = (peso, qtd) => {
        let valorFrete;

        switch (true) {
            case peso <= 300:
                valorFrete = 20.45;
                break;
            case peso <= 500:
                valorFrete = 20.95;
                break;
            case peso <= 1000:
                valorFrete = 21.95;
                break;
            case peso <= 2000:
                valorFrete = 23.45;
                break;
            case peso <= 3000:
                valorFrete = 23.95;
                break;
            case peso <= 4000:
                valorFrete = 24.95;
                break;
            case peso <= 5000:
                valorFrete = 25.95;
                break;
            case peso <= 9000:
                valorFrete = 41.95;
                break;
            case peso <= 13000:
                valorFrete = 65.95;
                break;
            case peso <= 17000:
                valorFrete = 73.45;
                break;
            case peso <= 23000:
                valorFrete = 85.95;
                break;
            case peso <= 30000:
                valorFrete = 98.95;
                break;
            case peso <= 40000:
                valorFrete = 109.45;
                break;
            case peso <= 50000:
                valorFrete = 116.95;
                break;
            case peso <= 60000:
                valorFrete = 124.95;
                break;
            case peso <= 70000:
                valorFrete = 141.45;
                break;
            case peso <= 80000:
                valorFrete = 156.95;
                break;
            case peso <= 90000:
                valorFrete = 174.95;
                break;
            case peso <= 100000:
                valorFrete = 199.95;
                break;
            case peso <= 125000:
                valorFrete = 223.45;
                break;
            case peso <= 150000:
                valorFrete = 237.45;
                break;
            default:
                valorFrete = 249.45;
        }

        return valorFrete * qtd;
    };

    const handleCalculate = (e) => {
        e.preventDefault();

        const price = parseFloat(productPrice);
        const qtd = parseInt(quantidade);
        const freteCalculado = calcularFrete(peso, qtd);

        let custoFixoCalculado = price < 79 ? 6 : 0;
        let tarifaMinimaCalculada = price < 79 ? (categoria === 'Clássico' ? 0.115 : 0.165) : (categoria === 'Clássico' ? 0.115 : 0.165); // 6% ou 11.5% ou 16.5%
        let tarifaMaximaCalculada = price < 79 ? (categoria === 'Clássico' ? 0.115 : 0.165) : (categoria === 'Clássico' ? 0.115 : 0.165); // 6% ou 11.5% ou 16.5%

        let commissionCalculada = price * tarifaMinimaCalculada;

        let total = price + commissionCalculada + custoFixoCalculado;

        if (parcelamento === 'Até 18x sem juros') {
            total *= 1.18;
        }

        setCustoFixo(custoFixoCalculado);
        setTarifaMinima(tarifaMinimaCalculada);
        setTarifaMaxima(tarifaMaximaCalculada);
        setCommission(commissionCalculada);
        setFrete(freteCalculado);

        if (price < 79) {
            setTotalPrice((price - custoFixoCalculado - commissionCalculada).toFixed(2));
        } else {
            setTotalPrice((price - commissionCalculada - freteCalculado).toFixed(2));
        }
    };





    return (
        <>
            <Navbar />
            <div className="container mt-page">
                <h1 className="mb-4">Tela de Precificação</h1>
                <form onSubmit={handleCalculate} className="row g-3">
                    <div className="col-md-6">
                        <label htmlFor="productPrice" className="form-label">Preço do Produto</label>
                        <input
                            type="text"
                            className="form-control"
                            id="productPrice"
                            value={productPrice}
                            onChange={(e) => setProductPrice(e.target.value.replace(",", "."))}
                        />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="quantidade" className="form-label">Quantidade</label>
                        <input type="number" className="form-control" id="quantidade" value={quantidade} onChange={(e) => setQuantidade(e.target.value)} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="peso" className="form-label">Peso (em gramas)</label>
                        <input type="number" className="form-control" id="peso" value={peso} onChange={(e) => setPeso(e.target.value)} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="categoria" className="form-label">Categoria</label>
                        <select className="form-select" id="categoria" value={categoria} onChange={(e) => setCategoria(e.target.value)}>
                            <option value="">Selecione...</option>
                            <option value="Clássico">Clássico</option>
                            <option value="Premium">Premium</option>
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="parcelamento" className="form-label">Parcelamento</label>
                        <select className="form-select" id="parcelamento" value={parcelamento} onChange={(e) => setParcelamento(e.target.value)}>
                            <option value="">Selecione...</option>
                            <option value="Sem parcelamento">Sem parcelamento</option>
                            <option value="Até 18x sem juros">Até 18x sem juros</option>
                        </select>
                    </div>
                    <div className="col-12">
                        <button type="submit" className="btn btn-primary">Calcular</button>
                    </div>
                </form>
                {totalPrice && (
                    <div className="mt-3 border rounded p-3 shadow-sm">
                        <h2 className="mb-3">Detalhes do Cálculo</h2>
                        <div className="d-flex justify-content-between mb-2">
                            <span>Preço do Produto:</span>
                            <span>R${productPrice}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <span>Quantidade:</span>
                            <span>{quantidade}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <span>Peso (em gramas):</span>
                            <span>{peso}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <span>Categoria:</span>
                            <span>{categoria}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <span>Parcelamento:</span>
                            <span>{parcelamento}</span>
                        </div>
                        {custoFixo > 0 && (
                            <div className="d-flex justify-content-between mb-2">
                                <span>Valor do Frete:</span>
                                <span>R${frete.toFixed(2)} (PAGO PELO COMPRADOR)</span>
                            </div>
                        )}
                        <div className="d-flex justify-content-between mb-2">
                            <span>Custo Fixo:</span>
                            <span>R${custoFixo}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <span>Comissão:</span>
                            <span>R${commission.toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <span>Frete:</span>
                            <span>R${frete.toFixed(2)}</span>
                        </div>
                        <div className="mt-3">
                            <h3 className="mb-2">Sobra: R${totalPrice}</h3>

                        </div>
                    </div>
                )}

            </div>
        </>
    );
}


export default Precificacao;
